import request from '@/utils/request'

const BASE = '/api/Extend/MemberPortrait'

export function getMemberPortraitOverview(memberId) {
  return request({
    url: `${BASE}/overview`,
    method: 'get',
    data: { memberId }
  })
}

export function getMemberPortraitBillingList(data) {
  return request({
    url: `${BASE}/billing-list`,
    method: 'get',
    data
  })
}

export function getMemberPortraitConsumeList(data) {
  return request({
    url: `${BASE}/consume-list`,
    method: 'get',
    data
  })
}

export function getMemberPortraitRefundList(data) {
  return request({
    url: `${BASE}/refund-list`,
    method: 'get',
    data
  })
}

export function getMemberPortraitAppointmentList(data) {
  return request({
    url: `${BASE}/appointment-list`,
    method: 'get',
    data
  })
}

export function getMemberPortraitInviteList(data) {
  return request({
    url: `${BASE}/invite-list`,
    method: 'get',
    data
  })
}

export function getMemberPortraitServiceLogList(data) {
  return request({
    url: `${BASE}/service-log-list`,
    method: 'get',
    data
  })
}

export function getMemberPortraitOldLogList(data) {
  return request({
    url: `${BASE}/old-log-list`,
    method: 'get',
    data
  })
}
